var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJuliafloresrjIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.4 156.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#442c1b;}.cls-2{fill:#9ac125;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.74,156.34H27.54A27.41,27.41,0,0,1,.16,129L0,32.16A27.36,27.36,0,0,1,27.32,4.74H62.2a5,5,0,0,1,0,10H27.38A17.38,17.38,0,0,0,10,32.12v0L10.16,129a17.42,17.42,0,0,0,17.38,17.35h95.2A17.4,17.4,0,0,0,140.12,129V97.18a5,5,0,0,1,10,0V129A27.41,27.41,0,0,1,122.74,156.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.91,1.49A5.09,5.09,0,0,0,150.21,0L113,.78A73.06,73.06,0,0,0,41.55,71l-1.46,38.44L22.25,127.32l-.31.31a3.92,3.92,0,0,0-1.1,2.07h0a3.82,3.82,0,0,0-.08.75h0a4,4,0,0,0,1,2.63c0,.06.09.13.15.19h0c.06.06.13.1.2.16a4,4,0,0,0,2.62,1h0a3.82,3.82,0,0,0,.75-.08h0a3.85,3.85,0,0,0,2.07-1.1l.31-.31,17.72-17.65,38.81-1.47a73,73,0,0,0,70.19-71.41L155.4,5.2A5.15,5.15,0,0,0,153.91,1.49Zm-7.29,40.79a65,65,0,0,1-62.5,63.57L54,107,68,93a3.39,3.39,0,0,0,.64.07h37.44a4,4,0,0,0,0-8H76L92.19,68.94h36.25a4,4,0,0,0,0-8H100.22L109,52.23l6-6h19.2a4,4,0,0,0,0-8H119.56a3.88,3.88,0,0,0-.89-1.34c-.06-.07-.13-.12-.19-.18s-.11-.13-.18-.19a3.72,3.72,0,0,0-1.34-.88V21a4,4,0,1,0-8,0V40.27l-6,6L94.28,55V26.78a4,4,0,0,0-8,0V63L70.16,79.22V49.1a4,4,0,1,0-8,0V86.54a3.5,3.5,0,0,0,.07.65L48.42,101.05l1.13-29.77a65,65,0,0,1,63.57-62.5l34.22-.72Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuliafloresrjIcon);
export default __webpack_public_path__ + "static/media/juliafloresrj-icon.eebb939b67976de5eb076164c2f38cd6.svg";
export { ForwardRef as ReactComponent };